import { FC } from 'react';
import styled from 'styled-components';

interface PrimaryButtonProps {
  onclick?: (e: any) => void;
  fill?: string;
  width?: string;
  title?: any;
  backgroundcolor?:string;
  type?:string
  disabled?: boolean;
}

const StyledButton = styled.button<PrimaryButtonProps>`
  height: 5rem;
  width: ${({ width }) => width || '100%'};
  border-radius: 5px;
  background-color:${({backgroundcolor}) => (backgroundcolor ? backgroundcolor : 'var(--primary)')};
  color: ${({ fill }) => (fill ? 'white' : 'var(--primary)')};
  cursor: pointer;
  text-align: center;
  align-items:center;
  display: flex;
  padding: 0.5rem 1rem;
  justify-content:center;
   @media (max-width: 990px) {
        width: 50%;
    }
   @media (max-width: 768px) {
        margin-top: 3rem;
      
    }
   @media (max-width: 510px) {
        width: 100%;
    }

`;

const Button: FC<PrimaryButtonProps> = ({
  onclick,
  width,
  title,
  backgroundcolor,
  type,
  fill,
  disabled
}) => {
  return (
    <StyledButton
      onClick={onclick}
      width={width}
      backgroundcolor={backgroundcolor}
      fill={fill}
      type={type}
      disabled={disabled}
    >
      {title}
    </StyledButton>
  );
};

export default Button;